var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiHeartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.41 1.52h-.4a6.2 6.2 0 00-4.36 1.77L13.3 4.63 12 3.29A6.1 6.1 0 007.65 1.5 6.2 6.2 0 003.3 3.29a6.09 6.09 0 000 8.61l.26.26 6.89 6.85 1.63 1.63.03.03.64.64a.79.79 0 00.57.23.82.82 0 00.56-.23l2.31-2.29 6.88-6.84.26-.27a6.1 6.1 0 001.35-6.64 6.04 6.04 0 00-2.25-2.73c-.9-.6-1.94-.95-3.02-1.02zm1.1-1.37A7.75 7.75 0 0019 0v.01a7.35 7.35 0 00-1.9.24 7.68 7.68 0 00-3.51 1.98l-.27.27-.26-.27A7.53 7.53 0 0010.58.58a7.7 7.7 0 00-8.34 1.64 7.59 7.59 0 000 10.75l.26.26 8.49 8.43.03.03.68.68a2.28 2.28 0 002.5.5c.27-.12.53-.29.74-.5l2.3-2.29 6.89-6.84.26-.26a7.6 7.6 0 001.68-8.28A7.54 7.54 0 0020.5.15z",
    clipRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--heart-empty-09aceedde2335f089b9e885787b9e35d.svg";
export { SvgIconUiHeartEmpty as Component };